import { useState, useRef, useEffect } from "react"
import styled from "styled-components"

//Import UI components to be used
import { Form } from '../form/FormComponents'
import HConnectModal from "./HConnectModal"
import ConnectInput from "./ConnectInput"

//setup for language State
import useTranslation from "../../hooks/useTranslation";

import { useModalStack } from "../../context/modalStackContext"

const SearchContainer = styled.div`
    height: "100%";

    @media (min-width: ${({ theme }) => theme.breakpoint.xs}) {
        display: ${(props) => props.$alwaysOn ? 'block' : 'none'};
    }
`

const HConnectControl = ({
    data,
    onSelect,
    placeholder,
    valueName,
    entity,
    modalTitle,
    modalOpacity = 0.5,
    isRed,
    $alwaysOn,
    parentId,
    parentField,
    options,
    persistValue,
    testId,
    origin = false,
    id,
    name,
    subObject,
    onClear,
    autoOpen,
    inputId,
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const [sync, setSync] = useState(false);
    const searchContainer = useRef(null);
    const { t } = useTranslation()
    const inputRef = useRef(null);
    const modalIdRef = useRef(null);

    const { pushModal, updateModal } = useModalStack();

    //Hide & Show the Modal
    const showModal = () => {
        modalIdRef.current = pushModal(HConnectModal, () => ({
            isVisible: true, // Always true when pushed to stack
            setIsVisible,
            data,
            valueName,
            onSelect,
            entity,
            modalTitle,
            modalOpacity,
            parentId,
            parentField,
            options,
            persistValue,
            testId,
            origin
        }));

        if (inputRef.current) {
            inputRef.current.blur(); // Blurs input to prevent keyboard pop-up
        }
        setIsVisible(true);
    }

    useEffect(() => {
        if (!isVisible) modalIdRef.current = null;
    }, [isVisible]);

    useEffect(() => {
        if (autoOpen) showModal()
    }, []);

    useEffect(() => {
        if (modalIdRef.current) {
            updateModal(modalIdRef.current, () => ({
                data,
            }))
        };
    }, [data])

    return (
        <SearchContainer ref={searchContainer} $alwaysOn={$alwaysOn}>
            <Form.Group >
                <ConnectInput
                    type="text"
                    valueName={valueName || ''}
                    name={name || entity}
                    showModal={showModal}
                    placeholder={t(placeholder)}
                    isRed={isRed}
                    autoComplete="off"
                    ref={inputRef}
                    readonly
                    pointerEvents="none"
                    testId={testId}
                    origin={origin}
                    entity={entity}
                    id={id}
                    onSelect={onSelect}
                    onClear={onClear}
                    sync={sync}
                    setSync={setSync}
                    inputId={inputId}
                />
            </Form.Group>
            {/* Modals are now managed by the modal stack context */}
        </SearchContainer>
    );
};

export default HConnectControl;
